import React from 'react';
import { Col, Row } from 'react-bootstrap';
import styles from 'assets/scss/wizard/emetSectionForm.module.scss';

/**
 * @component QuestionHeader
 * @description
 * Componente encargado de mostrar la instrucción general y el texto principal de una pregunta.
 * Se utiliza como parte de una sección del examen para mantener el encabezado limpio y reutilizable.
 *
 * @param {Object} props
 * @param {string} props.instruction - Texto de instrucciones o contexto para el candidato
 * @param {string} props.question - Texto principal de la pregunta
 *
 * @returns {JSX.Element}
 *
 * @example
 * <QuestionHeader
 *   instruction="Read the question carefully."
 *   question="What is the capital of France?"
 * />
 */
const QuestionHeader = ({ instruction, question }) => (
	<>
		<Row className={styles.instruction}>
			<Col>{instruction}</Col>
		</Row>
		<Row className={`${styles.question} mt-3`}>
			<Col>{question}</Col>
		</Row>
	</>
);

export default QuestionHeader;